"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDrawUtil = void 0;
const core_api_1 = require("@ikegps/core-api");
const model_1 = require("../model");
const unit_1 = require("../unit");
class IkeDrawUtil {
    static getBaseOffsetLabelText(capture, marker) {
        const labelText = marker.label.text;
        if (marker.y > capture.resolution.height) {
            return ['↓ ' + labelText];
        }
        return labelText;
    }
    static getBaseLabelText(marker, options) {
        const units = options.units;
        const labelText = marker.label.text;
        let textLines = [];
        if (labelText.length > 0) {
            textLines = textLines.concat(labelText);
        }
        const offset = marker.offset;
        if (offset && offset > 0) {
            const offsetText = unit_1.IkeUnit.display(offset, units, unit_1.IkeUnit.METER);
            return [`${offsetText} - ${textLines[0]}`];
        }
        return textLines;
    }
    static getMarkerLabelText(capture, marker, options) {
        var _a;
        const units = options.units;
        const isInsightMarker = marker.insight && !marker.insight.applied;
        const isInsightMarkerLabelsVisible = options.isInsightMarkerLabelsVisible;
        const detection_class = (_a = marker.insight) === null || _a === void 0 ? void 0 : _a.detection_class;
        if (marker.type === core_api_1.MarkerType.BASE) {
            return IkeDrawUtil.getBaseLabelText(marker, options);
        }
        if (marker.type === core_api_1.MarkerType.BASE_OFFSET) {
            return IkeDrawUtil.getBaseOffsetLabelText(capture, marker);
        }
        const label = marker.label;
        const labelLinks = label.links;
        const output = [];
        if (labelLinks.length > 0) {
            const outputText = {};
            for (const link of labelLinks) {
                link.distanceUnit = units;
                const title = link.annotationLabel;
                outputText[title] = (outputText[title] || 0) + 1;
            }
            // Squash text into a single line
            for (const textString of Object.keys(outputText)) {
                const count = outputText[textString];
                if (count < 2) {
                    output.push(textString);
                }
                else {
                    output.push(`${count}x ${textString}`);
                }
            }
        }
        for (const text of label.text) {
            output.push(text);
        }
        if (isInsightMarker &&
            isInsightMarkerLabelsVisible &&
            detection_class &&
            !(0, model_1.isInsightOffsetDetectionClass)(detection_class || '')) {
            output.push(detection_class);
        }
        // The test (output.length == 2) is only valid if one of them is the marker value.
        // This assumption is not guaranteed anymore with the detection class.
        // This part of the code might eventually require a refactor, if more if statements are added in the future.
        if (marker.value) {
            output.push(unit_1.IkeUnit.display(marker.value, units, unit_1.IkeUnit.METER));
            if (output.length === 2) {
                return [`${output[1]} - ${output[0]}`];
            }
        }
        return output;
    }
    static getLineLabelText(line, options) {
        const units = options.units;
        const output = line.label.text.slice();
        output.push(unit_1.IkeUnit.display(line.value, units, unit_1.IkeUnit.METER));
        if (output.length === 2) {
            return [`${output[1]} - ${output[0]}`];
        }
        return output;
    }
}
exports.IkeDrawUtil = IkeDrawUtil;
//# sourceMappingURL=draw.util.js.map